<script setup lang="ts">
import * as echarts from 'echarts'
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { useElementSize } from '@vueuse/core'

// 页面配置
definePage({
  name: 'position-decomposition',
  meta: {
    title: '持仓分解',
  },
})
const coreHoldingDataBox = reactive([
  { name: '核心仓', value: 41.7, color: '#409eff' },
  { name: '主力仓', value: 25.89, color: '#67c23a' },
  { name: '观察仓', value: 20.70, color: '#e6a23c' },
  { name: '其它', value: 10.71, color: '#808080' },

])

// 模拟核心仓数据

// 模拟核心仓占比数据
const coreHoldingRatioData = reactive([
  { name: '腾讯控股', value: 42.37, color: '#409eff' },
  { name: '阿里巴巴 - W', value: 22.45, color: '#67c23a' },
  { name: '小米集团 - W', value: 12.61, color: '#e6a23c' },
  { name: '中芯国际', value: 11.64, color: '#f56c6c' },
  { name: '美团 - W', value: 9.13, color: '#909399' },
  { name: '其它', value: 1.70, color: '#808080' },
])

// 模拟占比例明细数据
const holdingDetailData = reactive([
  {
    name: '腾讯控股',
    code: '00700.HK',
    marketValue: '6072.85亿',
    cycle: '92天',
    coreRatio: '42.37%',
    totalRatio: '11.02%',
  },
  {
    name: '阿里巴巴 - W',
    code: '09988.HK',
    marketValue: '32117.59亿',
    cycle: '92天',
    coreRatio: '22.45%',
    totalRatio: '11.53%',
  },
  {
    name: '小米集团 ',
    code: '1988.HK',
    marketValue: '3217.59亿',
    cycle: '92天',
    coreRatio: '22.45%',
    totalRatio: '11.53%',
  },
  {
    name: '中芯国际',
    code: '09288.HK',
    marketValue: '327.59亿',
    cycle: '92天',
    coreRatio: '22.45%',
    totalRatio: '11.52%',
  },
])
const activeName = ref('a')
const result = ref('2025/12/25')
const showPicker = ref(false)
const pickerValue = ref([])
function onConfirm({ selectedValues }: any) {
  result.value = selectedValues.join('/')
  pickerValue.value = selectedValues
  // selectedTimevalue.value = selectedValues
  showPicker.value = false
}
// 添加响应式数据
const updateTime = ref('2025/12/25 17:30') // 当前更新时间

// 时间选择器改变事件
const title = ref('核心仓占比')
// const title2 = ref('占比例明细')
// 排序逻辑
const sortField = ref('')
const sortDirection = ref('')
function sortTable(field: keyof typeof holdingDetailData[0], direction: string) {
  // 如果点击同一个字段，则切换升序/降序
  if (sortField.value === field) {
    if (sortDirection.value === 'asc') {
      sortDirection.value = 'desc'
    }
    else {
      sortDirection.value = 'asc'
    }
  }
  else {
    // 点击不同字段，设置新字段为升序
    sortField.value = field
    sortDirection.value = direction
  }

  // 对数据进行排序
  holdingDetailData.sort((a, b) => {
    let valueA: any = a[field]
    let valueB: any = b[field]

    // 如果是数值，移除单位并转换为数字
    if (field === 'marketValue') {
      valueA = Number.parseFloat(valueA.replace(/[^\d.-]/g, ''))
      valueB = Number.parseFloat(valueB.replace(/[^\d.-]/g, ''))
    }
    else if (field === 'cycle') {
      valueA = Number.parseInt(valueA.replace(/\D/g, ''))
      valueB = Number.parseInt(valueB.replace(/\D/g, ''))
    }

    if (sortDirection.value === 'asc') {
      return valueA > valueB ? 1 : -1
    }
    else {
      return valueA < valueB ? 1 : -1
    }
  })
}
function tabsfun() {
  if (activeName.value === 'a') {
    title.value = '核心仓'
  }
  else if (activeName.value === 'b') {
    title.value = '主力仓'
  }
  else {
    title.value = '观察仓'
  }
}

// ECharts 实例
const chartRef1 = ref<HTMLDivElement | null>(null)
const chartRef2 = ref<HTMLDivElement | null>(null)
let chartInstance1: echarts.ECharts | null = null
let chartInstance2: echarts.ECharts | null = null

// 初始化第一个图表（核心仓占比）
function initChart1() {
  if (!chartRef1.value) {
    return
  }

  // 创建ECharts实例
  chartInstance1 = echarts.init(chartRef1.value)

  // 配置项 - 使用饼图展示核心仓占比
  const option1 = {
    title: {
    text: '23.11%',
    left: 'center',
    top: 'center',
    textStyle: {
      fontSize: 20,
      fontWeight: 'bold',
      color: '#333'
    }
  },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      orient: 'horizontal', // 水平排列
      left: 'center', // 居中对齐
      top: 'bottom', // 位置在底部
      data: coreHoldingDataBox.map(item => item.name),
      textStyle: {
        color: '#333',
      },
    },
    series: [
      {
        name: '仓位占比',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '14',
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: coreHoldingDataBox.map(item => ({
          value: item.value,
          name: item.name,
          itemStyle: {
            color: item.color,
          },
        })),

      },
    ],
    backgroundColor: 'transparent',
  }

  chartInstance1.setOption(option1)

  // 监听窗口大小变化，调整图表大小
  window.addEventListener('resize', () => {
    if (chartInstance1) {
      chartInstance1.resize()
    }
  })
}

// 初始化第二个图表（核心仓个股占比）
function initChart2() {
  if (!chartRef2.value) {
    return
  }

  // 创建ECharts实例
  chartInstance2 = echarts.init(chartRef2.value)

  // 配置项 - 使用环形图展示核心仓个股占比
  const option2 = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      orient: 'vertical',
      // left: 'right', // 图例放在右侧
      top: 'middle', // 垂直居中
      data: coreHoldingRatioData.map(item => item.name),
      textStyle: {
        color: '#333',
         rich: {
        name: {
          width: 80,         // 固定名称宽度，确保百分比对齐
          fontSize: 12,
          padding: [0, 0, 0, 5]
        },
        value: {
          width: 50,         // 固定数值宽度
          fontSize: 10,
          align: 'right'     // 数值右对齐
        }
      }
      },
      right: '0',
      formatter: function(name:string) {
      // 假设你的数据结构中包含 value，需要先通过 name 找到对应的数值
      let targetValue;
      coreHoldingRatioData.forEach(item => {
        if (item.name === name) {
          targetValue = item.value;
        }
      });
      // 返回富文本格式：{样式名|文本}
      return `{name|${name}}{value|${targetValue}%}`;
    },
    },

    series: [
      {
        name: '核心仓个股占比',
        type: 'pie',
        radius: ['25%', '50%'],
        center: ['22%', '50%'], // 将饼图向左偏移，为右侧图例留出空间
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '14',
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: coreHoldingRatioData.map(item => ({
          value: item.value,
          name: item.name,
          itemStyle: {
            color: item.color,
          },
        })),
      },
    ],
    backgroundColor: 'transparent',
  }

  chartInstance2.setOption(option2)

  // 监听窗口大小变化，调整图表大小
  window.addEventListener('resize', () => {
    if (chartInstance2) {
      chartInstance2.resize()
    }
  })
}

// 组件挂载后初始化图表
onMounted(() => {
  initChart1()
  initChart2()
})

// 组件卸载前清理
onUnmounted(() => {
  if (chartInstance1) {
    chartInstance1.dispose()
  }
  if (chartInstance2) {
    chartInstance2.dispose()
  }
})

const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page">
    <div class="fund-flow-page">
      <div class="tabdiv" :style="{ top: navbarHeight }" ref="refTabConten" >
        <van-tabs v-model:active="activeName" @change="tabsfun()" line-width="9px">
          <van-tab title="核心仓" name="a" />
          <van-tab title="主力仓" name="b" />
          <van-tab title="观察仓" name="c" />
        </van-tabs>
      </div>
 <div :style="{ height: `${tabContenHeight}px` }" />
      <!-- 提示信息 -->
      <div class="notice-bar">
        <div class="time-display">
          数据更新时间：{{ updateTime }}
        </div>
        <div class="time-display" @click="showPicker = true">
          <div class="flex items-center">
            <div>{{ result }}</div>
            <FmIcon name="tdesign:chevron-down" class="text-18px"></FmIcon>
          </div>
        </div>
        <!-- <el-date-picker v-model="selectedTime" type="datetime" placeholder="选择时间" format="YYYY/MM/DD HH:mm"
          value-format="YYYY/MM/DD HH:mm" class="time-picker" @change="handleTimeChange" /> -->
        <!-- <van-date-picker v-model="selectedTime" title="选择日期" format="YYYY/MM/DD HH:mm" value-format="YYYY/MM/DD HH:mm" /> -->
      </div>
      <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
        <van-date-picker
          :model-value="pickerValue" title="选择日期" format="YYYY/MM/DD HH:mm" value-format="YYYY/MM/DD HH:mm"
          @confirm="onConfirm" @cancel="showPicker = false"
        />
      </van-popup>

      <!-- 核心仓占比区域 -->
      <div class="core-holding-section">
        <div class="section-header flex items-center">
          <span>{{ title }}占比</span>
          <!-- <div class="section-actions"> -->
            <img src="@/assets/images/icon2 (4).png" alt="" :style="{ width:'14px',height:'14px'}" class="mx-10px">
            <img src="@/assets/images/icon2 (5).png" alt="" :style="{ width:'12px',height:'12px'}" >
          <!-- </div> -->
        </div>

        <div class="holding-info">
          <div class="holding-chart-container">
            <div ref="chartRef1" class="chart-container" />
          </div>

          <div class="holding-stats">
            <div class="stat-item" style=" border-right: 1px solid #eee;">
              <span class="label">股票数</span>
              <span class="value">共6只</span>
            </div>
            <div class="stat-item">
              <span class="label">市值</span>
              <span class="value">1.43万亿</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 核心仓个股占比区域 -->
      <div class="core-holding-detail-section">
        <div class="section-header !p-t-15px">
          <span>{{ title }}个股占比</span>
        </div>

        <div class="holding-detail-container">
          <div ref="chartRef2" class="chart-container2" />

          <!-- <div class="legend-container">
            <div v-for="(item, index) in coreHoldingRatioData" :key="index" class="legend-item">
              <div class="legend-color" :style="{ backgroundColor: item.color }" />
              <div class="legend-text">
                {{ item.name }}
              </div>
              <div class="legend-value">
                {{ item.value }}%
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- 占比明细区域 -->
      <div class="holding-detail-section">
        <div class="section-header2">
          <span>占比明细</span>
        </div>

        <div class="detail-table">
          <div class="table-header">
            <div class="header-cell">
              名称
            </div>
            <div class="header-cell">
              持仓市值
              <div class="sort-icons !right-20px">
                <i class="sort-icon sort-asc" @click="sortTable('marketValue', 'asc')">▲</i>
                <i class="sort-icon sort-desc" @click="sortTable('marketValue', 'desc')">▼</i>
              </div>
            </div>
            <div class="header-cell">
              入池周期
              <div class="sort-icons !right-20px">
                <i class="sort-icon sort-asc" @click="sortTable('cycle', 'asc')">▲</i>
                <i class="sort-icon sort-desc" @click="sortTable('cycle', 'desc')">▼</i>
              </div>
            </div>
            <div class="header-cell">
              <div class="header--min">
                占核心仓比
              </div>
              <div class="header--min">
                占总持仓比
              </div>
              <div class="sort-icons !right-10px">
                <i class="sort-icon sort-asc" @click="sortTable('cycle', 'asc')">▲</i>
                <i class="sort-icon sort-desc" @click="sortTable('cycle', 'desc')">▼</i>
              </div>
            </div>
          </div>

          <div class="table-body">
            <div v-for="(item, index) in holdingDetailData" :key="index" class="table-row flex items-center">
              <div class="cell">
                <div class="stock-name">
                  {{ item.name }}
                </div>
                <div class="stock-code">
                  {{ item.code }}
                </div>
              </div>
              <div class="cell stock-name">
                {{ item.marketValue }}
              </div>
              <div class="cell stock-name">
                {{ item.cycle }}
              </div>
              <div class="cell">
                <div class="stock-name">
                  {{ item.coreRatio }}
                </div>
                <div class="stock-code">
                  {{ item.totalRatio }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FmPageLayout>
</template>

<style scoped lang="scss">
.fund-flow-page {
  min-height: 100vh;
  background-color: #f5f5f5;

  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tabdiv {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 0;
  color: white;
  background-color: #007aff;
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
}

.back-btn {
  padding: 8px;
  color: white;
  cursor: pointer;
  background: none;
  border: none;
}

.notice-bar {
  display: flex;
  justify-content: space-between;
  // margin-bottom: 16px;
  height: 17px;
  padding: 5px 8px;
  font-size: 12px;
  color: #999;
  text-align: center;
  background-color: white;
}

.core-holding-section {
  margin-bottom: 16px;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 8px 0;
  // border-bottom: 1px solid #eee;

  span {
    font-family: PingFangSC, "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: #333;
    text-align: left;
  }
}

.section-header2 {
  align-items: center;
  justify-content: flex-start;
  padding: 16px;

  // border-bottom: 1px solid #eee;
  span {
    font-family: PingFangSC, "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: #333;
    text-align: left;
  }
}

.section-actions {
  display: flex;
  gap: 10px;
  margin: 0 10px;

  img {
    width: 14px;
    height: 14px;
  }
}

.info-btn {
  padding: 8px;
  color: #999;
  cursor: pointer;
  background: none;
  border: none;
}

.holding-info {
  // display: flex;
  gap: 16px;
  padding: 0 16px;
}

.holding-chart-container {
  // flex: 1;
  width: 100%;
  height: 250px;
  // overflow: hidden;
  border-radius: 8px;
}

.chart-container {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  background-color: white;
}

.chart-container2 {
  width: 100%;
  height: 100%;
  min-height: 280px;
  // overflow: hidden;
  background-color: white;
}

.holding-stats {
  display: flex;
  // flex-direction: column;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  border-top: 1px solid #eee;
}

.stat-item {
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  gap: 20px;
  justify-content: center;
  height: 46px;
  font-size: 14px;
  line-height: 46px;
  color: #333;
}

.label {
  font-family: PingFangSC, "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  color: #999;
  text-align: left;
}

.value {

  // font-weight: 500;
  font-family: PingFangSC, "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  color: #333;
  text-align: left;
}

.core-holding-detail-section {
  margin-bottom: 16px;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.holding-detail-container {
  width: 100%;
  min-height: 300px;
  // display: flex;
  // gap: 16px;
  padding: 0 16px;
}

.legend-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
}

.legend-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-text {
  font-size: 14px;
  color: #333;
}

.legend-value {
  margin-left: auto;
  font-size: 14px;
  color: #666;
}

.holding-detail-section {
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.detail-table {
  border-top: 1px solid #eee;
}

.table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.header-cell {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #666;
  text-align: left;

  .header--min {
    font-size: 12px;
    line-height: 14px;
  }
}

.table-body {
  /* display: grid; */
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.table-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.cell {
  width: 24%;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.stock-name {
  font-weight: 600;
}

.stock-code {
  font-size: 12px;
  color: #666;
}

.time-display {
  font-size: 12px;
  color: #999;
}

.time-picker {
  :deep(.el-input__wrapper) {
    padding: 0;
    font-size: 12px;
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
}

::v-deep .van-tabs__nav {
  background-color: #f1f2f7;
}

.sort-icons {
  position: absolute;
  top: 50%;
  right: 5px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transform: translateY(-50%);

  .sort-icon {
    font-size: 10px;
    line-height: 1;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  .sort-asc {
    margin-bottom: -4px;
  }
}
</style>
